// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1J6JW","title":"Images45_title__2FoNB","images":"Images45_images__2rZRN"};